import React, { useState } from 'react';
import BackgroundSlider from './components/BackgroundSlider';
import Sidebar from './components/Sidebar';
import SocialIcons from './components/SocialIcons';
import MainContent from './components/MainContent';
import './App.css';

function App() {
    const [activeSection, setActiveSection] = useState('home');
    const [isAnimating, setIsAnimating] = useState(false);

    const handleSectionChange = (section) => {
        // Logika Booksy (który jest wbudowany w Sidebar, więc nie potrzebujemy 'book' tutaj)
        // Jeśli Books jest linkiem zewnętrznym, ten kod już jest niepotrzebny,
        // ale zostawiamy oryginalną logikę animacji, jeśli jej używasz.
        if (section === 'book') {
            setTimeout(() => {
                setIsAnimating(true);
            }, 300);
        } else {
            setIsAnimating(false);
        }
        setActiveSection(section);
    };

    return (
        <div className="app">
            <BackgroundSlider />
            <MainContent activeSection={activeSection} isAnimating={isAnimating} />
            {/* Sidebar teraz zawiera całą logikę (3 przyciski i widget Booksy) */}
            <Sidebar setActiveSection={handleSectionChange} />
            <SocialIcons />
        </div>
    );
}

export default App;
